import React, { Fragment } from 'react';

import { Link as ZinniaLink } from '@zapier/design-system';

import { ZAPIER_APP_BASE_URL } from 'app/common/constants';
import { useQueryZapierSession } from 'app/developer-v3/hooks';

function CreateZapTemplateButton() {
  const { isLoading: isLoadingUser, data } = useQueryZapierSession();
  const currentAccountId = data?.currentAccountId;
  const createZapTemplateUrl = new URL(
    '/webintent/create-template',
    ZAPIER_APP_BASE_URL
  );
  createZapTemplateUrl.search = new URLSearchParams({
    context: String(currentAccountId),
  }).toString();

  return (
    <Fragment>
      <ZinniaLink
        href={createZapTemplateUrl.href}
        isDisabled={isLoadingUser}
        target="_blank"
        variant="primary"
      >
        Create Zap Template
      </ZinniaLink>
    </Fragment>
  );
}

export default CreateZapTemplateButton;
